import { render, staticRenderFns } from "./BrakepadsClassroom1.vue?vue&type=template&id=26fe5910&scoped=true&"
import script from "./BrakepadsClassroom1.vue?vue&type=script&lang=js&"
export * from "./BrakepadsClassroom1.vue?vue&type=script&lang=js&"
import style0 from "./BrakepadsClassroom1.vue?vue&type=style&index=0&id=26fe5910&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fe5910",
  null
  
)

export default component.exports